import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';
import {
  ScheduleFilter,
  ScheduleState,
  SchedulePatientFilter,
  ScheduleDateFilter,
  ScheduleAppointment,
  ScheduleLogEntry
} from "./types";

const getDefaultFilter = (): ScheduleFilter => {
  return {
    entityId: "",
    patient: {
      firstName: "",
      lastName: "",
      phone: ""
    },
    calendar: {
      list: [],
      cache: {
        name: ""
      }
    },
    reasonList: [],
    date: {
      from: null,
      to: null
    },
    lastReminder: {
      from: null,
      to: null
    },
    statusList: [],
    created: {
      from: null,
      to: null
    },
    updated: {
      from: null,
      to: null
    },
    orderBy: "DATE",
    pageNumber: 1,
    rowsPerPage: 100
  };
};

const getDefaultState = (): ScheduleState => {
  return {
    calendars: [],
    status: [],
    typeStatus: [],
    filter: getDefaultFilter(),
  };
};

const filterOn = (filter: any) => {
  if (typeof filter === "object") {
    for (const field in filter) {
      const value = filter[field];
      if (field !== "cache") {
        if (Array.isArray(value)) {
          if (value.length) return true;
        } else if (value) {
          return true;
        }
      }
    }
  } else {
    return filter ? true : false;
  }
  return false;
};

const filesUrl = (path: string): string => {
  const { hostname } = window.location;
  let url = "https://files.";
  if (hostname.includes("localhost") || hostname.includes(".dev.")) {
    url += "dev."
  } else if (hostname.includes(".qa.")) {
    url += "qa."
  } else if (hostname.includes(".uat.")) {
    url += "uat."
  }
  url += "waitingmed.com" + (path ? "/" + path : "");
  return url;
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_CALENDARS(state: ScheduleState, calendars: Array<any>) {
      state.calendars = calendars;
    },
    SET_STATUS(state: ScheduleState, status: Array<any>) {
      state.status = status;
    },
    SET_TYPE_STATUS(state: ScheduleState, typeStatus: Array<any>) {
      state.typeStatus = typeStatus;
    },
    SET_PATIENT_FILTER(state: ScheduleState, filter: SchedulePatientFilter) {
      state.filter.patient = filter;
    },
    SET_CALENDAR_FILTER(state: ScheduleState, filter: any) {
      state.filter.calendar.cache.name = filter.name;
      state.filter.calendar.list = filter.list
    },
    SET_DATE_FILTER(state: ScheduleState, filter: ScheduleDateFilter) {
      state.filter.date = filter;
    },
    SET_LAST_REMINDER_FILTER(state: ScheduleState, filter: ScheduleDateFilter) {
      state.filter.lastReminder = filter;
    },
    SET_STATUS_FILTER(state: ScheduleState, filter: number[]) {
      state.filter.statusList = filter;
    },
    SET_CREATED_FILTER(state: ScheduleState, filter: ScheduleDateFilter) {
      state.filter.created = filter;
    },
    SET_UPDATED_FILTER(state: ScheduleState, filter: ScheduleDateFilter) {
      state.filter.updated = filter;
    },
    SET_ORDER_BY_FILTER(state: ScheduleState, field: string) {
      state.filter.orderBy = field;
      state.filter.pageNumber = 1;
    },
    SET_PAGE_NUMBER(state: ScheduleState, number: number) {
      state.filter.pageNumber = number;
    },
    SET_ROWS_PER_PAGE(state: ScheduleState, number: number) {
      state.filter.rowsPerPage = number;
    },
    RESET_FILTER(state: ScheduleState, entityId: string) {
      state.filter = getDefaultFilter();
      if (entityId) {
        state.filter.entityId = entityId;
      }
    },
    RESET_STATE(state: ScheduleState) {
      Object.assign(state, getDefaultState());
    },
    //   SET_INSURERS(state: GapState, insurers: Array<any>) {
    //     state.insurers = insurers;
    //   },
    //   SET_PROVIDERS(state: GapState, providers: Array<any>) {
    //     state.providers = providers;
    //   },
    //   SET_MEASURES(state: GapState, measures: Array<any>) {
    //     state.measures = measures;
    //   },
    //   SET_MEASURE_TYPES(state: GapState, measureTypes: Array<any>) {
    //     state.measureTypes = measureTypes;
    //   },
    //   SET_MEASURE_TYPE_TEMPLATES(
    //     state: GapState,
    //     measureTypeTemplates: Array<any>
    //   ) {
    //     state.measureTypeTemplates = measureTypeTemplates;
    //   },
    //   SET_PRIORITY(state: GapState, priority: Array<any>) {
    //     state.priority = priority;
    //   },
    //   SET_STATUS(state: GapState, status: Array<any>) {
    //     state.status = status;
    //   },
    //   SET_SUB_STATUS(state: GapState, subStatus: Array<any>) {
    //     state.subStatus = subStatus;
    //   },
    //   SET_CLOSE_REASONS(state: GapState, reasons: Array<any>) {
    //     state.closeReasons = reasons;
    //   },
    //   SET_LOG_TYPES(state: GapState, logTypes: Array<any>) {
    //     state.logTypes = logTypes;
    //   },
    //   SET_FILTER(state: GapState, filter: GapFilter) {
    //     state.filter = filter;
    //   },
    //   SET_ENTITY_FILTER(state: GapState, id: string) {
    //     state.filter.entityId = id;
    //   },
    //   SET_CAMPAIGN_FILTER(state: GapState, id: string) {
    //     state.filter.campaignId = id;
    //   },
    //   SET_PATIENT_FILTER(state: GapState, filter: GapPatientFilter) {
    //     state.filter.patient = filter;
    //   },
    //   SET_PROVIDER_FILTER(state: GapState, filter: ProviderFilter) {
    //     state.filter.provider.cache = filter;
    //     state.filter.provider.list = filter.list
    //       .filter((provider) => {
    //         return provider.checked;
    //       })
    //       .map((provider) => provider.id);
    //   },
    //   SET_MEASURE_FILTER(state: GapState, filter: GapMeasureFilter) {
    //     state.filter.measure = filter;
    //   },
    //   SET_REFDATE_FILTER(state: GapState, filter: GapDateFilter) {
    //     state.filter.referenceDate = filter;
    //   },
    //   SET_PRIORITY_FILTER(state: GapState, filter: string[]) {
    //     state.filter.priorityList = filter;
    //   },
    //   SET_STATUS_FILTER(state: GapState, filter: string[]) {
    //     state.filter.statusList = filter;
    //   },
    //   SET_SUB_STATUS_FILTER(state: GapState, filter: string[]) {
    //     state.filter.subStatusList = filter;
    //   },
    //   SET_CREATED_FILTER(state: GapState, filter: GapDateFilter) {
    //     state.filter.created = filter;
    //   },
    //   SET_UPDATED_FILTER(state: GapState, filter: GapDateFilter) {
    //     state.filter.updated = filter;
    //   },
    //   SET_ORDER_BY_FILTER(state: GapState, field: string) {
    //     state.filter.orderBy = field;
    //     state.filter.pageNumber = 1;
    //   },
    //   SET_PAGE_NUMBER(state: GapState, number: number) {
    //     state.filter.pageNumber = number;
    //   },
    //   SET_ROWS_PER_PAGE(state: GapState, number: number) {
    //     state.filter.rowsPerPage = number;
    //   },
  },
  actions: {
    async getApptList({ rootState }) {
      // SET FORM DATA
      const { filter } = rootState.schedule as ScheduleState;
      const params = new FormData();
      params.append("entityId", filter.entityId);
      params.append("calendarList", filter.calendar.list.join());
      params.append("firstName", filter.patient.firstName);
      params.append("lastName", filter.patient.lastName);
      params.append("phone", filter.patient.phone);
      params.append("dateFrom", moment(filter.date.from).format("YYYY-MM-DD"));
      params.append("dateTo", moment(filter.date.to).format("YYYY-MM-DD"));
      params.append("lastReminderDateFrom", moment(filter.lastReminder.from).format("YYYY-MM-DD"));
      params.append("lastReminderDateTo", moment(filter.lastReminder.to).format("YYYY-MM-DD"));
      params.append("statusList", filter.statusList.join());
      params.append("recordDateFrom", moment(filter.created.from).format("YYYY-MM-DD"));
      params.append("recordDateTo", moment(filter.created.to).format("YYYY-MM-DD"));
      params.append("lastUpdateFrom", moment(filter.updated.from).format("YYYY-MM-DD"));
      params.append("lastUpdateTo", moment(filter.updated.to).format("YYYY-MM-DD"));
      params.append("orderBy", filter.orderBy);
      params.append("pageNumber", filter.pageNumber.toString());
      params.append("rowsPerPage", filter.rowsPerPage.toString());
      // GET APPT LIST ASYNC
      const { data } = await Vue.axios.post("schedule/wmpc/appt/list", params);
      //
      return data;
    },
    async getApptRecord({ commit }, id: number) {
      // SET FORM DATA
      const params = new FormData();
      params.append("id", id.toString());
      // GET APPT ASYNC
      const { data } = await Vue.axios.post("schedule/wmpc/appt/record", params);
      //
      return data;
    },
    async getApptFileList({ commit }, id: number) {
      // SET FORM DATA
      const params = new FormData();
      params.append("id", id.toString());
      // GET FILES ASYNC
      const { data } = await Vue.axios.post("schedule/wmpc/appt/file/list", params);
      //
      return data;
    },
    async getCalendarViewEvents({ rootState }, dateFilter: ScheduleDateFilter) {
      // SET FORM DATA
      const params = new FormData();
      params.append("entityId", rootState.auth.entityId);
      params.append("dateFrom", moment(dateFilter.from).format("YYYY-MM-DD"));
      params.append("dateTo", moment(dateFilter.to).format("YYYY-MM-DD"));
      params.append("orderBy", "DATE");
      params.append("pageNumber", "1");
      params.append("rowsPerPage", "3000");
      // GET APPT LIST ASYNC
      const { data } = await Vue.axios.post("schedule/wmpc/appt/list", params);
      //
      return data.pageRows.map((appt) => {
        let start = appt.date;
        if (appt.time) {
          start += " " + appt.time;
        }
        return {
          id: appt.id,
          title: appt.patientName,
          start: moment(start).format(),
        };
      });
    },
    async getCalendars({ commit, rootState }) {
      // SET FORM PARAMS
      const params = new FormData();
      params.append("entityId", rootState.auth.entityId);
      //
      const { data } = await Vue.axios.post("schedule/calendar/list", params);
      commit("SET_CALENDARS", data);
    },
    async getCalendarReasons({ commit, rootState }, calendarId: number) {
      // SET FORM PARAMS
      const params = new FormData();
      params.append("calendarId", calendarId.toString());
      // GET REASONS ASYNC
      const { data } = await Vue.axios.post("schedule/calendar/reason/list", params);
      //
      return data;
    },
    async getEntityInsurers({ commit, rootState }, entityId: number) {
      // SET FORM PARAMS
      const params = new FormData();
      params.append("entityId", entityId.toString());
      // GET REASONS ASYNC
      const { data } = await Vue.axios.post("entity/insurer/list", params);
      //
      return data;
    },
    async getStatus({ commit, state }) {
      if (state.status.length) return;
      // GET STATUS LIST ASYNC
      const { data } = await Vue.axios.post("schedule/status/list");
      //
      commit("SET_STATUS", data);
    },
    async getTypeStatus({ commit, state }) {
      if (state.typeStatus.length) return;
      // GET TYPE STATUS LIST ASYNC
      const { data } = await Vue.axios.post("schedule/type/status/list");
      //
      commit("SET_TYPE_STATUS", data);
    },
    async saveAppt({ rootState }, appt: ScheduleAppointment) {
      // SET FORM DATA
      const params = new FormData();
      if (appt.id) params.append("id", appt.id.toString());
      if (appt.main.patient.id) params.append("patientId", appt.main.patient.id.toString());
      if (appt.main.time) params.append("time", appt.main.time);
      params.append("calendarId", appt.main.calendarId);
      params.append("reasonId", appt.main.reasonId);
      params.append("typeId", appt.main.typeId);
      params.append("date", appt.main.date!);
      params.append("sessionId", appt.main.sessionId);
      params.append("firstName", appt.main.patient.firstName!);
      params.append("lastName", appt.main.patient.lastName!);
      params.append("birthdate", appt.main.patient.birthdate!);
      params.append("phone", appt.main.patient.phone!);
      params.append("insurerId", appt.main.patient.insurer.id);
      params.append("insurerMemberId", appt.main.patient.insurer.memberId!);
      params.append("serviceDescription", appt.service.description!);
      params.append("serviceAddress", JSON.stringify(appt.service.address));
      params.append("fileList", appt.files.map((f) => f.key).join());
      params.append("EMR_PATIENT_ID", appt.main.patient.EMR_ID!);
      params.append("comments", appt.comment);
      params.append("lang", appt.main.lang);
      params.append("statusId", appt.main.statusId);
      // SAVE APPT ASYNC
      const { data } = await Vue.axios.post("schedule/appt/save", params);
      //
      return data;
    },
    async saveApptFile({ rootState }, { id, key }) {
      // SET FORM DATA
      const params = new FormData();
      params.append("id", id);
      params.append("key", key);
      // SAVE APPT ASYNC
      const { data } = await Vue.axios.post("schedule/appt/file/save", params);
      //
      return data;
    },
    async saveApptStatus({ rootState }, { id, statusId }) {
      // SET FORM DATA
      const params = new FormData();
      params.append("id", id);
      params.append("statusId", statusId);
      // SAVE APPT ASYNC
      const { data } = await Vue.axios.post("schedule/appt/status", params);
      //
      return data;
    },
    async saveApptLog({ commit }, entry: ScheduleLogEntry) {
      // SET FORM DATA
      const params = new FormData();
      params.append("apptId", entry.apptId.toString());
      params.append("typeId", entry.typeId);
      if (entry.statusId) params.append("statusId", entry.statusId!.toString());
      if (entry.comment) params.append("comment", entry.comment);
      // SAVE LOG ASYNC
      const { data } = await Vue.axios.post("schedule/appt/log/save", params);
      //
      return data;
    },
    async archiveApptFile({ rootState }, { id, fileId }) {
      // SET FORM DATA
      const params = new FormData();
      params.append("id", id);
      params.append("fileId", fileId);
      // SAVE APPT ASYNC
      const { data } = await Vue.axios.post("schedule/appt/file/archive", params);
      //
      return data;
    },
    async uploadFile({ rootState }, file: File) {
      // SET FORM PARAMS
      const params = new FormData();
      params.append("files[0]", file);
      // UPLOAD FILE ASYNC
      const { data } = await axios.post(filesUrl("ul"), params);
      //
      return data;
    },
    async downloadFile({ rootState }, key: string) {
      window.location.href = filesUrl("dl/wm/" + key);
    },
    async sendApptCall({ commit }, id: number) {
      // SET FORM DATA
      const params = new FormData();
      params.append("apptId", id.toString());
      // SEND CALL ASYNC
      const { data } = await Vue.axios.post("schedule/appt/reminder/call", params);
      //
      return data;
    },
    async sendApptSMS({ commit }, id: number) {
      // SET FORM DATA
      const params = new FormData();
      params.append("apptId", id.toString());
      // SEND CALL ASYNC
      const { data } = await Vue.axios.post("schedule/appt/reminder/sms", params);
      //
      return data;
    },
  },
  getters: {
    patientFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.patient);
    },
    calendarFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.calendar);
    },
    reasonFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.reasonList);
    },
    dateFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.date);
    },
    lastReminderFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.lastReminder);
    },
    statusFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.statusList);
    },
    createdFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.created);
    },
    updatedFilterOn: (state: ScheduleState) => {
      return filterOn(state.filter.updated);
    },
  },
};
